import { Badge, Typography, styled } from '@mui/material';
import React, { createContext } from 'react';
import { GppGood } from '@mui/icons-material';
import { formatTime, formatTimeForceTimeZone, getFriendlyAddress, hoursMinToTimeString, iconMap } from './BookingUtilities';
import { GetOtherDomesticAddressPlaceholders } from '../components/igtm/BookingViews/DestinationViews/OtherDomesticAddress';
import { cWarn } from '../components/igtm/CustomLogger';
import { TaxiPlaceholders } from '../components/igtm/BookingViews/TravelModes/TaxiPlaceholders';

export const PointContext = createContext();

class PointContextProvider extends React.Component {

    constructor(props) {
        super(props);

        const {
            booking,
            point,
            index,
            bookingConfig,
            brandContext,
            brandContext:{
                textContent
            },
            searchRes
        } = props;

        this.textContent = textContent;
        this.bookingConfig = bookingConfig;
        this.brandContext = brandContext;

        this.state = {
            isLoading: true,
            hasFailed:false,
            booking,
            point,
            index,
            searchRes,
            destinationTitle:textContent.unknownDestination,
            transportIcon:<Typography className="iconHelp" variant="h6">?</Typography>,
            destinationIcon:<Typography className="iconHelp" variant="h6">?</Typography>,
            destinationBodyText:null,
            destinationTimeLabel:null,
            transportTitle:textContent.unknownTravelMode,
            transportBodyText:null,
            transportTimeLabel:null,
        };

        this.state = {
            ...this.state,
            ...this.prepareDestinationData(),
            ...this.prepareTransportData()
        }


        

        
    }

    componentDidMount() {
        
    }

    prepareDestinationData(){
        let destinationType = '';
        const {destination} = this.state.point;
        if(destination){
            ({type:destinationType} = destination);
        }
        const updateObject = {};


        const {destinationTypesMap} = this.bookingConfig;

        const destinationTypeInfo = destinationTypesMap[destination.type];

        const {
            index,
            booking:{
                bookingJson:{
                    legs = [],
                    destination:endDestination,
                    direction=''
                }
            }
        } = this.state;

        const lastLeg = ((index === 'destination') || (index === (legs.length - 1)));

        try {
            updateObject.destinationTitle = this.textContent[destinationTypeInfo.textKey];
            updateObject.destinationIcon = iconMap[destinationTypeInfo.icon];
            updateObject.destinationBodyText = getFriendlyAddress(destination);
            if('hoursMin' in destination){
                updateObject.destinationTimeLabel = hoursMinToTimeString(destination.hoursMin);
            }
            if(lastLeg){
                if('hoursMin' in endDestination){
                    updateObject.destinationTimeLabel = hoursMinToTimeString(endDestination.hoursMin);
                }
            }
        } catch (e) {
           // console.log('Error in assigining the text key from the following object:');
        }

        


        switch(destinationType){
            case 'otherDomesticAddress': {
                GetOtherDomesticAddressPlaceholders(this).then(({bodyText}) => {
                    updateObject.destinationBodyText = bodyText;
                    
                    if(!this.state.searchRes){
                        this.setState(updateObject);
                    }
                });
                break;
            }
            case 'internationalFlight': {


                const {bookingJson:{direction}} = this.state.booking;
                if (destination.flightData) {
                    const {flightNo='',flightData} = destination;
                    let airportLabel = destination.flightData.departureAirport;
                    if (direction === 'incoming') {
                        airportLabel = destination.flightData.arrivalAirport;
                    }

                    updateObject.destinationTitle = airportLabel;
                    
                    
                    const {airline=''} = flightData;
                    
                    if(flightData.manuallyEntered){
                        updateObject.destinationBodyText = (
                            <>
                                <strong>{flightNo &&  flightNo} {airline && airline}</strong><br/>
                                
                                {direction === 'outgoing' ?
                                
                                <>
                                <Typography variant="h5">{this.textContent.departingFlightTitle}</Typography>
                                {destination.flightData.departureAirportCode}{destination.flightData.departureTerminal ? `, ${this.textContent.flightLabelTerminal} ${destination.flightData.departureTerminal}` : ''} at {hoursMinToTimeString(destination.flightData.departureHoursMin)}
                                </>
                                :
                                <>
                                <Typography variant="h5">{this.textContent.arrivingFlightTitle}</Typography>
                                {destination.flightData.arrivalAirportCode}{destination.flightData.arrivalTerminal ? `, ${this.textContent.flightLabelTerminal} ${destination.flightData.arrivalTerminal}` : ''} at {hoursMinToTimeString(destination.flightData.arrivalHoursMin)}
                                </>
                                }
                            </>
                        );
                    }
                    else{
                        const startTime = new Date(destination.flightData.departureTime.date);
                        startTime.setHours(startTime.getHours() - 3);
                        updateObject.destinationTimeLabel = formatTime(startTime);

                        updateObject.destinationBodyText = (
                            <>
                                <strong>{flightNo &&  flightNo} {airline && airline}</strong><br/>
                                <Typography variant="h5">{this.textContent.departingFlightTitle}</Typography>
                                {destination.flightData.departureAirportCode}{destination.flightData.departureTerminal ? `, ${this.textContent.flightLabelTerminal} ${destination.flightData.departureTerminal}` : ''} at {formatTimeForceTimeZone(destination.flightData.departureTime.date)}
                                <Typography variant="h5">{this.textContent.arrivingFlightTitle}</Typography>
                                {destination.flightData.arrivalAirportCode}{destination.flightData.arrivalTerminal ? `, ${this.textContent.flightLabelTerminal} ${destination.flightData.arrivalTerminal}` : ''} at {formatTimeForceTimeZone(destination.flightData.arrivalTime.date)}
                            </>
                        );
                    }

                    
                }
                break;
            }
            case 'airport': {
                const {
                    stationAddress:{
                        name=''
                    } = {},
                    departing=false,
                    flightData:{
                        arrivalAirport='',
                        departureAirport='',
                    } = {
                        arrivalAirport:'',
                        departureAirport:'',
                    }
                } = this.state.point.destination;

                if(departing && departureAirport !== ''){
                    updateObject.destinationTitle = departureAirport;
                }
                if(!departing && arrivalAirport !== ''){
                    updateObject.destinationTitle = arrivalAirport;
                }
    
                updateObject.destinationTitle = name;
                break;
            }
            case 'trainStation': {
                const {
                    stationAddress = null
                } = destination;
                if (stationAddress) {
                    const {
                        Name='',
                        shortName=''
                    } = stationAddress;
                    updateObject.destinationTitle = `${Name} (${shortName})`;
                }
                break;
            }
            case 'inPersonDropoff': {
                if ('travelTime' in destination) {
                    if('hoursMin' in destination){
                        updateObject.destinationTimeLabel = hoursMinToTimeString(destination.hoursMin);
                    }
                    else{
                        updateObject.destinationTimeLabel = formatTime(destination.travelTime);
                    }
                    
                    updateObject.destinationBodyText = `Person dropping-off: ${destination.driverData.label}`;
                }
                break;
            }
            case 'inPersonCollection': {
                if ('travelTime' in destination) {
                    if('hoursMin' in destination){
                        updateObject.destinationTimeLabel = hoursMinToTimeString(destination.hoursMin);
                    }
                    else{
                        updateObject.destinationTimeLabel = formatTime(destination.travelTime);
                    }
                    updateObject.destinationBodyText = `Person collecting: ${destination.driverData.label}`;
                }
                break;
            }
            default: 
            break;
        }

        return updateObject;
    }
    

    prepareTransportData(){
        
        let updateObject = {
            transportTitle:this.textContent.unknownTravelMode,
            transportBodyText:null,
            transportTimeLabel:null,
        }
        let modeInfo = {};
        
        const {travelModesMap:modeTypesMap} = this.bookingConfig;

        const {direction} = this.state.booking;

        if(this.state.point) {
            const {
                mode=null,
                transportData={}
            } = this.state.point;
            
            if (mode) {

                try {
                    modeInfo = modeTypesMap[mode];
                    updateObject.transportIcon = iconMap[modeInfo.icon];
                    updateObject.transportTitle = this.textContent[modeInfo.textKey];
                    

                    const StyledBadge = styled(Badge)(({ theme }) => ({
                        '& .MuiBadge-badge': {
                          right: 6,
                          top: 6,
                          border: `2px solid ${theme.palette.background.paper}`,
                          padding: '0 0px',
                          width:'14px',
                          minWidth:'14px',
                          height:'14px',
                          backgroundColor:'#34B233'
                        },
                      }));

                    switch (mode) {
                        case 'schoolCoach': {
                            if(transportData){
                                updateObject.transportIcon = (
                                    <StyledBadge sx={{
                                        verticalAlign:'unset'  
                                    }} badgeContent={<GppGood sx={{width:10, height:10}} />} color="primary">
                                        {iconMap[modeInfo.icon]}
                                    </StyledBadge>);
                                try{
                                    const {
                                        route:{
                                            route:{
                                                name:routeName='',
                                            },
                                            originStop:{
                                                routeStop:{
                                                    StopLocation:{
                                                        name:originStopName='',
                                                    },
                                                    time:originTime
                                                }
                                            },
                                            destinationStop:{
                                                routeStop:{
                                                    StopLocation:{
                                                        name:destinationStopName='',
                                                    },
                                                    time:destinationTime
                                                }
                                            }
                                        }
                                    } = transportData;

                                
                                    updateObject.transportBodyText = (
                                        <div>
                                            <strong>
                                                {routeName}
                                            </strong>
                                            <div>
                                                Departing {originStopName} at {
                                                formatTimeForceTimeZone(originTime)
                                            }
                                            </div>
                                            <div>
                                                Arriving {destinationStopName} at {
                                                formatTimeForceTimeZone(destinationTime)
                                            }
                                            </div>
                                        </div>
                                    );
                                }
                                catch(e){
                                    cWarn(e);
                                }
                            }
                            break;
                        }
                        case 'bookMeATaxi': {
                            
                                TaxiPlaceholders(this).then((updateData) => {
                                    if(updateData){
                                        updateObject = {...updateObject,...updateData};

                                        this.setState(updateObject);
                                    }
                                });        
                            

                            // return null;
                            break;
                        }

                        case 'privateCar': {
                            if(transportData){

                                if('driverData' in transportData) {
                                    if ('travelTime' in transportData.driverData && direction === 'outgoing') {
                                        updateObject.transportTimeLabel = formatTime(transportData.driverData.travelTime);
                                    }
                                    if(direction ==='outgoing'){
                                        if('hoursMin' in transportData.driverData){
                                            updateObject.transportTimeLabel = hoursMinToTimeString(transportData.driverData.hoursMin);
                                        }
                                    }
                                    let driverName = 'Unknown';
                                    if ('driverData' in transportData) {
                                        if (transportData.type === 'existing') {
                                            if ('meta' in transportData.driverData) {
                                                driverName = transportData.driverData.meta.label;
                                            }
                                        } else {
                                            driverName = transportData.driverData.newDriverName;
                                        }
                                    }


                                    updateObject.transportBodyText = (<>
                                        Driven By {driverName}<br/>
                                        {'vehicleData' in transportData &&
                                        <>
                                            {'make' in transportData.vehicleData && <span
                                                style={{textTransform: 'capitalize'}}>{transportData.vehicleData.colour} {transportData.vehicleData.make}, </span>} {transportData.registration && <>Registration: <span
                                            style={{textTransform: 'uppercase'}}>{transportData.registration}</span></>}
                                        </>
                                        }
                                    </>);
                                }
                            }
                            break;
                        }
                        case 'getMeThere': {
                            
                            updateObject.transportBodyText = this.textContent.getMeThereSummaryText;
                            
                            break;
                        }
                        case 'train': {

                            
                            if(transportData) {
                                if(transportData.route){
                                    updateObject.transportBodyText = (
                                        <>
                                            {transportData.route.route.map((leg, index) =>
                                                (
                                                    <div key={index}>
                                                        <div>
                                                            {leg.company}, {this.textContent.textDeparting} {leg.deparutreStop} {this.textContent.textAt} {leg.departureFormatted}. {this.textContent.textArriving} {leg.arrivalStop} {this.textContent.textAt} {leg.arrivalFormatted}
                                                        </div>
                                                    </div>
                                                ))}
                                        </>
                                    );
                                }
                            }
                            break;
                        }
                        case 'walk':

                        break;

                        case 'flying':{
                            const {
                                transportData:{
                                    flightNo='',
                                    flightData={}
                                }
                            } = this.state.point;

                            if(Object.keys(flightData).length !== 0){

                                const {
                                    airline='',
                                    manuallyEntered=false,
                                    departureAirportCode='',
                                    departureTerminal='',
                                    departureHoursMin=false,
                                    arrivalAirportCode='',
                                    arrivalTerminal='',
                                    arrivalHoursMin=false,
                                    departureTime:{
                                        date:departureTimeStamp=''
                                    } = {},
                                    arrivalTime:{
                                        date:arrivalTimeStamp=''
                                    } = {}
                                } = flightData;

                                const {
                                    departingFlightTitle,
                                    arrivingFlightTitle,
                                    flightLabelTerminal
                                } = this.textContent;

                                if(manuallyEntered){
                                    updateObject.transportBodyText = (
                                        <>
                                            <strong>{flightNo} {airline}</strong><br/>
                                            
                                            {direction === 'outgoing' ?
                                            
                                            <>
                                            <Typography variant="h5">{departingFlightTitle}</Typography>
                                            {departureAirportCode}{departureTerminal ? `, ${flightLabelTerminal} ${departureTerminal}` : ''} at {hoursMinToTimeString(departureHoursMin)}
                                            </>
                                            :
                                            <>
                                            <Typography variant="h5">{arrivingFlightTitle}</Typography>
                                            {arrivalAirportCode}{arrivalTerminal ? `, ${flightLabelTerminal} ${arrivalTerminal}` : ''} at {hoursMinToTimeString(arrivalHoursMin)}
                                            </>
                                            }
                                        </>);
                                }
                                else{

                                    const startTime = new Date(departureTimeStamp);
                                    startTime.setHours(startTime.getHours() - 3);
                                    updateObject.transportTimeLabel = formatTime(startTime);
            
                                    updateObject.transportBodyText = (
                                        <>
                                            <strong>{flightNo} {airline}</strong><br/>
                                            <Typography variant="h5">{departingFlightTitle}</Typography>
                                            {departureAirportCode}{departureTerminal ? `, ${flightLabelTerminal} ${departureTerminal}` : ''} at {formatTimeForceTimeZone(departureTimeStamp)}
                                            <Typography variant="h5">{arrivingFlightTitle}</Typography>
                                            {arrivalAirportCode}{arrivalTerminal ? `, ${flightLabelTerminal} ${arrivalTerminal}` : ''} at {formatTimeForceTimeZone(arrivalTimeStamp)}
                                        </>
                                    );
                                }
                            }


                            break;
                        }

                        case 'other':
                            updateObject.transportTimeLabel = formatTime(transportData.travelTime);
                            updateObject.transportBodyText = (
                                <>
                                    Transport type: {transportData.name}<br/>
                                    Description: {transportData.description}
                                </>
                            );
                            break;
                        case 'publicTransport':
                            updateObject.transportTimeLabel = formatTime(transportData.travelTime);
                            updateObject.transportBodyText = (
                                <>
                                    Transport type: {transportData.name}<br/>
                                    Description: {transportData.description}
                                </>
                            );


                            if ('travelTime' in transportData && direction === 'outgoing') {
                                updateObject.transportTimeLabel = formatTime(transportData.driverData.travelTime);
                            }
                            if(direction ==='outgoing'){
                                if('hoursMin' in transportData){
                                    updateObject.transportTimeLabel = hoursMinToTimeString(transportData.hoursMin);
                                }
                            }

                            break;
                        default:
                            console.error('The destination or origin type has not been identified');
                    }
                } catch (e) {
                    cWarn(e);
                }
            }
        }
        
        return updateObject;
    }

    render() {
        return (
            <PointContext.Provider value={{
                ...this.state,
                setState:this.setState.bind(this)
            }}>
                {this.props.children}
            </PointContext.Provider>
        );
    }
}

export default PointContextProvider;